<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        AP Outstanding
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend><span>As Of Date</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date" :state="!$v.model.tgl2.$error"></b-form-input>
            <b-input-group-append
              ><b-button class="ml-3 btn btn-success" @click="getData()"> <i class="fa fa-play"></i> Process</b-button></b-input-group-append
            >
          </b-input-group>
        </b-col>
      </b-row>

      <b-card no-body v-show="showSummary">
        <b-tabs card v-model="model.tabIndex">
          <b-tab title="Summary by Vendor & Currency">
            <b-row v-if="filterShow == 'Hide'">
              <b-col lg="6">
                <b-form-group label="Filter" label-cols-sm="1" label-size="sm" label-for="filterInput" class="mb-0">
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                  <b> {{ filterShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-table
              class="mb-0"
              ref="tableOri"
              sticky-header="600px"
              outlined
              responsive
              striped
              hover
              style="font-size: smaller"
              :items="aging.rekap"
              :fields="tblLcy.fields"
              :current-page="tblLcy.page"
              :per-page="tblLcy.limit"
              :sort-by.sync="tblLcy.sortBy"
              :sort-desc.sync="tblLcy.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:head(totalLcy)="data">
                <span>Total Outstand in {{ uanguser }} (Local Currency)</span>
              </template>
              <template v-slot:cell(totalLcy)="data">
                {{ data.item.totalLcy | numFormat }}
              </template>
              <template v-slot:head(aging1Lcy)="data">
                <span v-if="aging.seting.apAge1" class="text-info">{{ aging.seting.apAge1 }} Days</span>
                <span v-else class="text-info">30 Days</span>
              </template>
              <template v-slot:cell(aging1Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 1)">
                  {{ data.item.aging1Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging2Lcy)="data">
                <span v-if="aging.seting.apAge2" class="text-info">{{ aging.seting.apAge2 }} Days</span>
                <span v-else class="text-info">60 Days</span>
              </template>
              <template v-slot:cell(aging2Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 2)">
                  {{ data.item.aging2Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging3Lcy)="data">
                <span v-if="aging.seting.apAge3" class="text-info">{{ aging.seting.apAge3 }} Days</span>
                <span v-else class="text-info">90 Days</span>
              </template>
              <template v-slot:cell(aging3Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 3)">
                  {{ data.item.aging3Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging4Lcy)="data">
                <span v-if="aging.seting.apAge4" class="text-info">{{ aging.seting.apAge4 }} Days</span>
                <span v-else class="text-info">180 Days</span>
              </template>
              <template v-slot:cell(aging4Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 4)">
                  {{ data.item.aging4Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging5Lcy)="data">
                <span v-if="aging.seting.apAge5" class="text-info"> > {{ aging.seting.apAge5 }} Days</span>
                <span v-else class="text-info"> > 180 Days</span>
              </template>
              <template v-slot:cell(aging5Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 5)">
                  {{ data.item.aging5Lcy | numFormat }}
                </a>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div style="font-weight: bolder">Total Outstanding : {{ uanguser }} {{ aging.totalLcy | numFormat }}</div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" style="text-align: center">
                    <div>
                      Showing {{ (tblLcy.page - 1) * tblLcy.limit + 1 }} to <span v-if="tblLcy.page * tblLcy.limit > tblLcy.total">{{ tblLcy.total }}</span>
                      <span v-else>{{ tblLcy.page * tblLcy.limit }}</span> of {{ tblLcy.total }} entries, <span class="ml-3 mr-1">limit per page :</span>
                      <input type="number" style="width: 80px" v-model="tblLcy.limit" />
                    </div>
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                      <b> {{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="6">
                    <b-pagination align="right" :total-rows="tblLcy.total" :per-page="tblLcy.limit" v-model="tblLcy.page"></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Exchange Rate">
            <b-row>
              <b-col md="10" lg="9">
                <table style="width: 100%">
                  <thead>
                    <tr>
                      <th width="120px">Date</th>
                      <th>From Currency</th>
                      <th width="70px" style="text-align: center">Into</th>
                      <th style="text-align: center">Rate</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, idx) in aging.valas" :key="idx">
                      <td>{{ row.tanggal | moment("DD MMM YYYY") }}</td>
                      <td>{{ row.matauang }}</td>
                      <td>{{ aging.seting.matauang }}</td>
                      <td style="text-align: right">
                        <b-form-input v-model="row.kurs" type="number"></b-form-input>
                      </td>
                      <td>{{ row.uraian }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <b-col md="2" lg="3">
                <b-button class="ml-3 btn btn-warning" @click="processValas()"> <i class="fa fa-calculator"></i> RE-PROCESS FOREIGN CURRENCY</b-button>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Summary by Vendor" active>
            <b-row v-if="filterShow == 'Hide'">
              <b-col lg="6">
                <b-form-group label="Filter" label-cols-sm="1" label-size="sm" label-for="filterInput" class="mb-0">
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                  <b> {{ filterShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-table
              class="mb-0"
              ref="tableOri"
              sticky-header="600px"
              outlined
              responsive
              striped
              hover
              style="font-size: smaller"
              :items="aging.rekapVendor"
              :fields="tblRekap.fields"
              :current-page="tblRekap.page"
              :per-page="tblRekap.limit"
              :sort-by.sync="tblRekap.sortBy"
              :sort-desc.sync="tblRekap.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:cell(latestPaym)="data">
                <span v-if="data.item.latestPaym">
                  {{ data.item.latestPaym | moment("DD MMM YYYY") }}
                </span>
              </template>

              <template v-slot:head(totalLcy)="data">
                <span>Total Outstand in {{ uanguser }} (Local Currency)</span>
              </template>
              <template v-slot:cell(totalLcy)="data">
                {{ data.item.totalLcy | numFormat }}
              </template>
              <template v-slot:head(aging1Lcy)="data">
                <span v-if="aging.seting.apAge1" class="text-info">{{ aging.seting.apAge1 }} Days</span>
                <span v-else class="text-info">30 Days</span>
              </template>
              <template v-slot:cell(aging1Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 1)">
                  {{ data.item.aging1Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging2Lcy)="data">
                <span v-if="aging.seting.apAge2" class="text-info">{{ aging.seting.apAge2 }} Days</span>
                <span v-else class="text-info">60 Days</span>
              </template>
              <template v-slot:cell(aging2Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 2)">
                  {{ data.item.aging2Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging3Lcy)="data">
                <span v-if="aging.seting.apAge3" class="text-info">{{ aging.seting.apAge3 }} Days</span>
                <span v-else class="text-info">90 Days</span>
              </template>
              <template v-slot:cell(aging3Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 3)">
                  {{ data.item.aging3Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging4Lcy)="data">
                <span v-if="aging.seting.apAge4" class="text-info">{{ aging.seting.apAge4 }} Days</span>
                <span v-else class="text-info">180 Days</span>
              </template>
              <template v-slot:cell(aging4Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 4)">
                  {{ data.item.aging4Lcy | numFormat }}
                </a>
              </template>
              <template v-slot:head(aging5Lcy)="data">
                <span v-if="aging.seting.apAge5" class="text-info"> > {{ aging.seting.apAge5 }} Days</span>
                <span v-else class="text-info"> > 180 Days</span>
              </template>
              <template v-slot:cell(aging5Lcy)="data">
                <a href="javascript:void(0)" @click.stop="getDetail(data.item, 5)">
                  {{ data.item.aging5Lcy | numFormat }}
                </a>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div style="font-weight: bolder">Total Outstanding : {{ uanguser }} {{ aging.totalLcy | numFormat }}</div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" style="text-align: center">
                    <div>
                      Showing {{ (tblRekap.page - 1) * tblRekap.limit + 1 }} to <span v-if="tblRekap.page * tblRekap.limit > tblRekap.total">{{ tblRekap.total }}</span>
                      <span v-else>{{ tblRekap.page * tblRekap.limit }}</span> of {{ tblRekap.total }} entries, <span class="ml-3 mr-1">limit per page :</span>
                      <input type="number" style="width: 80px" v-model="tblRekap.limit" />
                    </div>
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                      <b> {{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="6">
                    <b-pagination align="right" :total-rows="tblRekap.total" :per-page="tblRekap.limit" v-model="tblRekap.page"></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Detail AP Outstanding">
            <b-row v-if="filterShow == 'Hide'">
              <b-col lg="6">
                <b-form-group label="Filter" label-cols-sm="1" label-size="sm" label-for="filterDtl" class="mb-0">
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterDtl" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filterDtl" @click="filterDtl = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox v-model="filterDtlShow" value="Hide" unchecked-value="Show" switch>
                  <b> {{ filterDtlShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-table
              class="mb-0"
              ref="tableLcy"
              sticky-header="600px"
              outlined
              responsive
              striped
              hover
              style="font-size: smaller"
              :items="aging.detail"
              :fields="tblDetail.fields"
              :current-page="tblDetail.page"
              :per-page="tblDetail.limit"
              :sort-by.sync="tblDetail.sortBy"
              :sort-desc.sync="tblDetail.sortDesc"
              :filter="filterDtlInput"
              :filterIncludedFields="filterDtlOn"
              @filtered="onFilterDetail"
            >
              <template v-slot:cell(totalinv)="data">
                {{ data.item.totalinv | numFormat }}
              </template>
              <template v-slot:cell(outstand)="data">
                {{ data.item.outstand | numFormat }}
              </template>
              <template v-slot:cell(outstandLcy)="data">
                {{ data.item.outstandLcy | numFormat }}
              </template>
              <template v-slot:cell(aging3Ori)="data">
                {{ data.item.aging | numFormat }}
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div style="font-weight: bolder">Total Outstanding : {{ uanguser }} {{ aging.totalLcy | numFormat }}</div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" style="text-align: center">
                    <div>
                      Showing {{ (tblDetail.page - 1) * tblDetail.limit + 1 }} to <span v-if="tblDetail.page * tblDetail.limit > tblDetail.total">{{ tblDetail.total }}</span>
                      <span v-else>{{ tblDetail.page * tblDetail.limit }}</span> of {{ tblDetail.total }} entries, <span class="ml-3 mr-1">limit per page :</span>
                      <input type="number" style="width: 80px" v-model="tblDetail.limit" />
                    </div>
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                      <b> {{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="6">
                    <b-pagination align="right" :total-rows="tblDetail.total" :per-page="tblDetail.limit" v-model="tblDetail.page"></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;

  table {
    font-size: smaller;
    th {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    td {
      border-bottom: 1px solid #f5f5f5;
      padding: 0 10px;
      height: 25px;
    }

    tr.selisih {
      background: yellow;
    }

    td.tebal {
      font-weight: bold;
    }

    td.subtotal {
      border-top: 2px solid #000 !important;
    }

    td.total {
      border-top: 2px solid #000 !important;
      background: #e6e6e6 !important;
    }

    td.grdtotal {
      border-top: 2px solid #000 !important;
      border-bottom: 2px double #000 !important;
      background: #e6e6e6 !important;
    }
    tbody tr:hover {
      background-color: rgba(0, 0, 0, 0.05) !important;
      cursor: default;
    }
  }
}
</style>

<script>
import moment from "moment";
import appaymplan from "../../apis/appaymplan";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      tgl2: { required },
    },
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showSummary: true,
      showPrintConfirm: false,
      showReport: false,
      reportUrl: null,
      model: { tabIndex: 0, kodeacc: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      aging: { rekap: [], detail: [], seting: {} },
      agingDtl: { list: [], outstand: 0, outstandLcy: 0 },
      subtotal: {},
      tblDetail: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "nomor",
            label: "AP Number",
            sortable: true,
          },
          {
            key: "vendor",
            label: "Vendor Code",
            sortable: true,
          },
          {
            key: "vendor_name",
            label: "Vendor Name",
            sortable: true,
          },
          {
            key: "postgrpname",
            label: "AP Posting Group",
            sortable: true,
          },
          {
            key: "po",
            label: "PO Number",
            sortable: true,
          },
          {
            key: "invoice",
            label: "Invoice #",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true,
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "totalinv",
            label: "Total Invoice",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstand",
            label: "Outstanding",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstandLcy",
            label: "Outstand LCY",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging",
            label: "Age (days)",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
        ],
      },
      tblLcy: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "vendor",
            label: "Vendor Code",
            thStyle: "width:120px",
            sortable: true,
          },
          {
            key: "vendor_name",
            label: "Vendor Name",
            sortable: true,
          },
          {
            key: "postgrpname",
            label: "AP Account Name",
            sortable: true,
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "totalLcy",
            label: "Total Outstanding (IDR)",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging1Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging2Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging3Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging4Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging5Lcy",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
        ],
      },
      tblRekap: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "vendor",
            label: "Vendor Code",
            thStyle: "width:120px",
            sortable: true,
          },
          {
            key: "vendor_name",
            label: "Vendor Name",
            sortable: true,
          },
          {
            key: "postgrpname",
            label: "AP Account Name",
            sortable: true,
          },
          {
            key: "totalLcy",
            label: "Total Outstanding (IDR)",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging1Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging2Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging3Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging4Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "aging5Lcy",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
        ],
      },
      filter: null,
      filterOn: [],
      filterShow: "Show",
      filterDtl: null,
      filterDtlInput: null,
      filterDtlOn: [],
      filterDtlShow: "Show",
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
      return this.model.account;
    },
  },
  watch: {
    // account: function(newval) {
    //   const obj=this.accounts.find(d => d.value === newval);
    //     this.model.namaacc=obj.text || '';
    //     this.model.kodeacc=obj.kodeacc;
    //     // console.log(`${this.model.account} | ${this.model.namaacc}`);
    // },
    filterShow: function (newval) {
      setTimeout(() => {
        if (this.filterShow == "Show") this.filter = "";
        this.filter = "";
      }, 200);
    },
    filterVndShow: function (newval) {
      setTimeout(() => {
        if (this.filterVndShow == "Show") this.filterVnd = "";
      }, 200);
    },
    filterDtlShow: function (newval) {
      setTimeout(() => {
        if (this.filterDtlShow == "Show") this.filterDtl = "";
      }, 200);
    },
    filterDtl: function (newval) {
      // this.isBusy=true;
      setTimeout(() => {
        if (this.filterDtlInput != newval) this.filterDtlInput = newval;
      }, 800);
    },
  },
  created: async function () {
    const tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD").add(1, "M").subtract(1, "day");
    this.model.tgl2 = tgl2.format("YYYY-MM-DD");
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      this.tblRekap.total = filteredItems.length;
      this.tblRekap.page = 1;
    },
    onFilterDetail(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblDetail.total = filteredItems.length;
      this.tblDetail.page = 1;
      this.totalDetail = filteredItems.reduce((a, b) => a + b.outstandLcy, 0);
    },
    processValas() {
      let apValas;
      this.aging.valas.forEach((uang, index) => {
        appaymplan.updateexchrate(uang);
        apValas = this.aging.rekap.reduce((newArr, item, idx) => {
          if (item.matauang === uang.matauang) {
            newArr.push({
              idx,
              totalOri: item.totalOri,
              aging1Ori: item.aging1Ori,
              aging2Ori: item.aging2Ori,
              aging3Ori: item.aging3Ori,
              aging4Ori: item.aging4Ori,
              aging5Ori: item.aging5Ori,
            });
          }
          return newArr;
        }, []);
        apValas.forEach((ap) => {
          this.aging.rekap[ap.idx].totalLcy = ap.totalOri * uang.kurs;
          this.aging.rekap[ap.idx].aging1Lcy = ap.aging1Ori * uang.kurs;
          this.aging.rekap[ap.idx].aging2Lcy = ap.aging2Ori * uang.kurs;
          this.aging.rekap[ap.idx].aging3Lcy = ap.aging3Ori * uang.kurs;
          this.aging.rekap[ap.idx].aging4Lcy = ap.aging4Ori * uang.kurs;
          this.aging.rekap[ap.idx].aging5Lcy = ap.aging5Ori * uang.kurs;
        });
        apValas = this.aging.detail.reduce((newArr, item, idx) => {
          if (item.matauang === uang.matauang) {
            newArr.push({ idx, outstand: item.outstand });
          }
          return newArr;
        }, []);
        apValas.forEach((ap) => {
          this.aging.detail[ap.idx].outstandLcy = ap.outstand * uang.kurs;
        });
      });
      const rekapVendor = [];
      let grpKey = { vendor: "", postgrpname: "" };
      let idxhasil = 0;
      this.aging.rekap.forEach((ap) => {
        if (grpKey.vendor !== ap.vendor || grpKey.postgrpname !== ap.postgrpname) {
          const row = {};
          for (var key in ap) {
            row[key] = ap[key];
          }
          rekapVendor.push(row);
          grpKey.vendor = ap.vendor;
          grpKey.postgrpname = ap.postgrpname;
          idxhasil += 1;
        } else {
          rekapVendor[idxhasil - 1].totalLcy += ap.totalLcy;
          rekapVendor[idxhasil - 1].aging1Lcy += ap.aging1Lcy;
          rekapVendor[idxhasil - 1].aging2Lcy += ap.aging2Lcy;
          rekapVendor[idxhasil - 1].aging3Lcy += ap.aging3Lcy;
          rekapVendor[idxhasil - 1].aging4Lcy += ap.aging4Lcy;
          rekapVendor[idxhasil - 1].aging5Lcy += ap.aging5Lcy;
        }
      });
      this.aging.rekapVendor = rekapVendor;
      this.$forceUpdate();
    },
    getData: async function (ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.showSummary = true;
        this.isLoading = true;
        const result = await appaymplan.outstandgroup(this.model);
        this.isLoading = false;
        if (result.success) {
          this.aging.rekap = result.data[0];
          this.aging.detail = result.data[1];
          this.aging.valas = result.data[2];
          this.aging.seting = result.data[3][0];
          this.aging.rekapVendor = result.data[4];
          this.aging.totalLcy = 0;
          this.aging.aging1Lcy = 0;
          this.aging.aging2Lcy = 0;
          this.aging.aging3Lcy = 0;
          this.aging.aging4Lcy = 0;
          this.aging.aging5Lcy = 0;
          this.aging.rekap.forEach((ap) => {
            this.aging.totalLcy += ap.totalLcy;
            this.aging.aging1Lcy += ap.aging1Lcy;
            this.aging.aging2Lcy += ap.aging2Lcy;
            this.aging.aging3Lcy += ap.aging3Lcy;
            this.aging.aging4Lcy += ap.aging4Lcy;
            this.aging.aging5Lcy += ap.aging5Lcy;
          });
          // this.$forceUpdate();
          this.tblDetail.total = this.aging.detail.length;
          this.totalDetail = this.aging.totalLcy;
          this.tblLcy.total = this.aging.rekap.length;
          this.tblRekap.total = this.aging.rekapVendor.length;
          if (result.message) toastr.warn(result.message, "WARNING", 10000);
        } else {
          if (result.message) toastr.error(result.message, "ERROR", 10000);
        }
      }
    },
    getDetail: function (row, col) {
      toastr.warn(row.vendor_name.toUpperCase(), `Loading Detail Outstanding`);
      setTimeout(() => {
        this.filterDtlOn = ["vendor"];
        this.filterDtl = row.vendor;
        this.filterDtlInput = row.vendor;
        this.filterDtlShow = "Hide";
        this.model.tabIndex = 3;
      }, 100);
      // this.$forceUpdate();
    },

    exportxls: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await appaymplan.outstandgroupexport(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR", 10000);
          }
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>
